<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase mr-2 minw">
        <v-img src="https://reg.hro-cigre.hr/img1/header_logo.png" alt="logo" width="80"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="mr-2 caption"
        >HRO CIGRÉ Berislavićeva 6, 10000 ZAGREB Tel.: 01 487 25 07, Fax: 01 487 25 01, E-mail: central@hro-cigre.hr www.hro-cigre.hr</span
      >
    </v-toolbar>

    <v-content>
      <ViewRegistration v-if="isViewRegistration" />
      <ViewRegistrationInd v-else-if="isViewRegistrationInd" />
      <RegisterInd v-else-if="isInd" :foreign="isForeign" />
      <Register v-else />
    </v-content>
  </v-app>
</template>

<script>
import Register from "./components/Register";
import RegisterInd from "./components/RegisterInd";
import ViewRegistration from "./components/ViewRegistration";
import ViewRegistrationInd from "./components/ViewRegistrationInd";

export default {
  name: "App",
  components: {
    Register,
    RegisterInd,
    ViewRegistration,
    ViewRegistrationInd,
  },
  data() {
    return {
      //
    };
  },
  computed: {
    isInd: function () {
      return window.location.href.includes("?rtype=ind");
    },
    isViewRegistration: function () {
      return window.location.href.includes("RegType=0");
    },
    isViewRegistrationInd: function () {
      return window.location.href.includes("RegType=1");
    },
    isForeign: function () {
      return window.location.href.includes("foreign=1");
    },
  },
};
</script>

<style scoped>
.minw {
  min-width: 130px;
}
</style>
